import { render, staticRenderFns } from "./dictaPublication.vue?vue&type=template&id=1fd609e2&scoped=true"
import script from "./dictaPublication.vue?vue&type=script&lang=js"
export * from "./dictaPublication.vue?vue&type=script&lang=js"
import style0 from "./dictaPublication.vue?vue&type=style&index=0&id=1fd609e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd609e2",
  null
  
)

export default component.exports